/** @jsxImportSource @emotion/react */
import { HelpCircle, Info, Settings } from 'lucide-react';
import { Pages } from 'modules/navigation/domain/enums/pages';
import React from 'react';
import type { DivProps } from '../../../../../../typings';
import MenuItem from '../menu-item/menu-item';
import * as S from './styles';

interface IProps extends DivProps {}

const MenuTechnical = React.memo(function MenuTechnicalIcon(props: IProps) {
  const { ...rest } = props;

  return (
    <S.MainBlock {...rest}>
      <MenuItem to={Pages.SETTINGS.INDEX} icon={<Settings size={16} />} label={'Настройки'} />
      <MenuItem to={Pages.ABOUT} icon={<Info size={16} />} label={'О приложении'} />
      <MenuItem to={'/help'} icon={<HelpCircle size={16} />} label={'Помощь'} disabled tooltip="В разработке" />
    </S.MainBlock>
  );
});

export default MenuTechnical;
